import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/api.ts'
import type { DispoCalendarEmployee } from '@shared/types'

interface UseDispositionTimelineParams {
  from: Date
  to: Date
  employeeIds?: number[]
  tenantId?: string
  /** When false, the query is disabled (no network request). Default: true. */
  enabled?: boolean
}

interface KalenderResponse {
  employees: DispoCalendarEmployee[]
  window: { from: string; to: string } | null
  dataSource: 'tanss' | 'none'
  error?: string
  warning?: string
}

export interface DispositionTimelineResult {
  employees: DispoCalendarEmployee[]
  warning?: string
}

export function useDispositionTimeline({ from, to, employeeIds, tenantId, enabled = true }: UseDispositionTimelineParams) {
  return useQuery<DispositionTimelineResult, Error>({
    queryKey: ['dispo-kalender', from.toISOString(), to.toISOString(), employeeIds, tenantId],
    enabled,
    queryFn: async () => {
      const params = new URLSearchParams({
        from: from.toISOString().slice(0, 10),
        to: to.toISOString().slice(0, 10),
      })
      if (employeeIds && employeeIds.length > 0) {
        params.set('employeeIds', employeeIds.join(','))
      }
      if (tenantId) {
        params.set('tenantId', tenantId)
      }
      const res = await apiClient.get<KalenderResponse>(`/dispo/kalender?${params.toString()}`)
      if (res.data.error && res.data.dataSource === 'none') {
        throw new Error(res.data.error)
      }
      return { employees: res.data.employees, warning: res.data.warning }
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
  })
}
